import {
  GET_PRODUCT_DETAIL,
  PRODUCT_DETAIL_ERROR,
  LOADING_PRODUCT_DETAIL
} from "./types";
import { firebase } from "../../firebase";
export const getProductDetail = id => async dispatch => {
  dispatch({
    type: LOADING_PRODUCT_DETAIL
  });
  try {
    let db = firebase.firestore();
    const snapshots = await db
      .collection("products")
      .doc(id)
      .get();

    let product = { id: snapshots.id, data: snapshots.data() };
    dispatch({
      type: GET_PRODUCT_DETAIL,
      payload: product
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_DETAIL_ERROR,
      payload: error.message
    });
  }
};
